import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class AssetBrandsService extends AxiosService {
    constructor() {
        super('management');
    }
  
    getBrands = async ({ cancelToken = null } = {}) => {
        return await this.get(
            `/asset-brands`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

}
export default new AssetBrandsService();
